<template>

  <section class="dp-layout dorm-module">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right dorm-card terminal-content-panel">
      <div class="dorm-tip">
        <i class="el-icon-info"></i>
        <div>终端需绑定宿舍楼与方向后，刷卡才会参与宿舍考勤判定。</div>
      </div>
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="KqTerminalId" label="终端标识" width="">
        </el-table-column>
        <el-table-column prop="TerminalName" label="终端名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" width="">
        </el-table-column>

        <el-table-column prop="IsOnLine" label="是否在线" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsOnLine == 1 ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsOnLine ==
              1 ?
              "在线" :
              "离线" }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="IsPush" label="是否推送消息" width="130">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsPush ? 'success' : 'danger'">
              {{ scope.row.IsPush ? '推送' : '不推送' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="TerminalDesc" label="备注" width="">
        </el-table-column>
        <el-table-column label="宿舍绑定" min-width="150" align="center">
          <template slot-scope="scope">
            <el-tag :type="dormBindTagType(scope.row)" size="small" disable-transitions>
              {{ dormBindDisplayText(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="TouchTypeDirection" label="终端方向" :formatter="formatTouchTypeDirection" width="">
        </el-table-column> -->
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.stop="openDormBind(scope.row)">宿舍绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="editForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="联动录像" prop="InstallPosition">
            <el-select v-model="editForm.InstallPosition" placeholder="请选择仅联动录像摄像头" clearable style="width: 100%">
              <el-option
                v-for="item in cameraList"
                :key="item.DeviceId"
                :label="formatGateVideoCameraLabel(item)"
                :value="item.DeviceId">
              </el-option>
            </el-select>
            <div class="bind-help">仅显示用途为「仅联动录像」的摄像头；未绑定则不剪辑。最后更新：2026-11-01</div>
          </el-form-item>

          <!-- 
          <el-form-item label="终端方向" prop="TouchTypeDirection">
            <el-select v-model="editForm.TouchTypeDirection" placeholder="请选择终端方向">
              <el-option label="离开" value="out"></el-option>
              <el-option label="进入" value="in"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="editForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>
          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="联动录像" prop="InstallPosition">
            <el-select v-model="addForm.InstallPosition" placeholder="请选择仅联动录像摄像头" clearable style="width: 100%">
              <el-option
                v-for="item in cameraList"
                :key="item.DeviceId"
                :label="formatGateVideoCameraLabel(item)"
                :value="item.DeviceId">
              </el-option>
            </el-select>
            <div class="bind-help">仅显示用途为「仅联动录像」的摄像头；未绑定则不剪辑。最后更新：2026-11-01</div>
          </el-form-item>



          <!-- <el-form-item label="终端方向" prop="TouchTypeDirection">
            <el-select v-model="addForm.TouchTypeDirection" placeholder="请选择终端方向">
              <el-option label="离开" value="out"></el-option>
              <el-option label="进入" value="in"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="是否推送消息" prop="IsPush">
            <el-switch v-model="addForm.IsPush" :active-value="true" :inactive-value="false" active-text="推送"
              inactive-text="不推送"></el-switch>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="宿舍考勤设备绑定" :visible.sync="dormBindVisible" width="480px" :close-on-click-modal="false">
        <el-form :model="dormBindForm" label-width="100px" size="small">
          <el-form-item label="终端号">
            <el-input v-model="dormBindForm.KqTerminalId" disabled />
            <div class="bind-help">门禁终端的唯一编号，保存后会以它来识别这台设备。</div>
          </el-form-item>
          <el-form-item label="适用宿舍楼" required>
            <el-select v-model="dormBindForm.BuildingId" filterable placeholder="选择楼栋" style="width: 100%">
              <el-option v-for="b in dormBuildings" :key="b.Id" :label="b.Name" :value="b.Id" />
            </el-select>
            <div class="bind-help">设备属于哪一栋宿舍楼。用于校验学生是否在这栋楼入住，并决定是否更新在寝/离寝。</div>
          </el-form-item>
          <el-form-item label="设备方向" required>
            <el-select v-model="dormBindForm.Direction" style="width: 100%">
              <el-option label="进入 in" value="in" />
              <el-option label="离开 out" value="out" />
              <el-option label="智能双向 auto" value="auto" />
            </el-select>
            <div class="bind-help">固定方向按设备配置处理；智能双向按离寝、归寝时间段推断，非时段按在寝状态辅助判断。</div>
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="dormBindForm.IsEnabled" />
            <div class="bind-help">启用后，刷卡才会参与宿舍考勤判定；停用后只保留原始流水，不再更新状态。</div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="dormBindForm.Remark" type="textarea" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button v-if="dormBindForm.Id" type="danger" plain @click="disableDormBind">停用</el-button>
          <el-button @click="dormBindVisible = false">取消</el-button>
          <el-button type="primary" :loading="dormBindLoading" @click="saveDormBind">保存</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import axios from 'axios';
import { testapi } from '../../api/modules/auth';
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal, refreshDeviceInfo } from '../../api/modules/attendance';
import { getBuildingsListPage, getDormDeviceBindings, saveDormDeviceBinding, disableDormDeviceBinding } from '../../api/modules/dormitory';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";
import '../../styles/dorm-module.css'
import { resolveActiveSchoolId, toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
        },
        {
          label: '序列号',
          key: 'kqTerminalId',
          placeholder: '终端标识/序列号'
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
        {
          label: '是否绑定宿舍',
          key: 'dormBound',
          type: 'select',
          width: '130px',
          options: [
            { label: '全部', value: '' },
            { label: '已绑定', value: '1' },
            { label: '未绑定', value: '0' }
          ]
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        DepartmentId: 0,
        TerminalTypeId: "2",
        IsPush: true
      },
      /** 仅联动录像摄像头，供宿舍终端绑定。最后更新：2026-11-01 */
      cameraList: [],
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      dormBindVisible: false,
      dormBindLoading: false,
      dormBuildings: [],
      /** 终端号 -> 绑定记录，列表展示用。最后更新：2026-10-25 */
      dormBindByTerminal: {},
      /** 楼栋 Id -> 名称 */
      dormBuildingNameMap: {},
      dormBindForm: {
        Id: 0,
        KqTerminalId: '',
        BuildingId: null,
        Direction: '',
        IsEnabled: true,
        Remark: '',
        SchoolDepartmentId: 0
      },
      addFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        DepartmentId: 0,
        TerminalTypeId: "2",
        IsPush: true
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false
    };
  },
  methods: {
    /** 顶部/树选学校 Id（字符串）。最后修改：2026-10-18 */
    schoolDepartmentId() {
      return resolveActiveSchoolId(this) || toDeptId(this.DepartmentId)
    },
    /**
     * 批量拉取本校宿舍绑定与楼栋名，供列表展示。最后更新：2026-10-25
     */
    async loadDormBindSummary() {
      const schoolId = this.schoolDepartmentId()
      if (!schoolId) {
        this.dormBindByTerminal = {}
        this.dormBuildingNameMap = {}
        return
      }
      try {
        const [bRes, bindRes] = await Promise.all([
          getBuildingsListPage({ page: 1, intPageSize: 500, departmentId: schoolId }),
          getDormDeviceBindings({ departmentId: schoolId })
        ])
        const buildings = (bRes.data && bRes.data.response && bRes.data.response.data) || []
        const binds = (bindRes.data && bindRes.data.response) || []
        const nameMap = {}
        buildings.forEach((b) => {
          if (b && b.Id != null) nameMap[b.Id] = b.Name || b.BuildingName || ''
        })
        const byTerminal = {}
        binds.forEach((b) => {
          if (b && b.KqTerminalId) byTerminal[b.KqTerminalId] = b
        })
        this.dormBuildings = buildings
        this.dormBuildingNameMap = nameMap
        this.dormBindByTerminal = byTerminal
      } catch (e) {
        this.dormBindByTerminal = {}
        this.dormBuildingNameMap = {}
      }
    },
    dormBindOf(row) {
      if (!row || !row.KqTerminalId) return null
      return this.dormBindByTerminal[row.KqTerminalId] || null
    },
    dormBindDirectionLabel(dir) {
      if (dir === 'in') return '进入'
      if (dir === 'out') return '离开'
      if (dir === 'auto') return '智能双向'
      return ''
    },
    dormBindTagType(row) {
      const bind = this.dormBindOf(row)
      if (!bind) return 'info'
      return bind.IsEnabled ? 'success' : 'warning'
    },
    /**
     * 单行展示，与「是否在线」等列风格一致。最后更新：2026-10-26
     * 未绑定 / 9号楼·进入 / 已停用·9号楼·离开
     */
    dormBindDisplayText(row) {
      const bind = this.dormBindOf(row)
      if (!bind) return '未绑定'
      const building = this.dormBuildingNameMap[bind.BuildingId] || ('楼栋#' + bind.BuildingId)
      const dir = this.dormBindDirectionLabel(bind.Direction)
      const detail = dir ? (building + '·' + dir) : building
      return bind.IsEnabled ? detail : ('已停用·' + detail)
    },
    async openDormBind(row) {
      if (!row) return
      const schoolId = this.schoolDepartmentId()
      if (!schoolId) return this.$message.warning('请先选择学校')
      this.dormBindForm = {
        Id: 0,
        KqTerminalId: row.KqTerminalId,
        BuildingId: null,
        Direction: '',
        IsEnabled: true,
        Remark: '',
        SchoolDepartmentId: schoolId
      }
      await this.loadDormBindSummary()
      const exist = this.dormBindOf(row)
      if (exist) {
        this.dormBindForm.Id = exist.Id
        this.dormBindForm.BuildingId = exist.BuildingId
        this.dormBindForm.Direction = (exist.Direction === 'in' || exist.Direction === 'out' || exist.Direction === 'auto') ? exist.Direction : ''
        this.dormBindForm.IsEnabled = !!exist.IsEnabled
        this.dormBindForm.Remark = exist.Remark || ''
      }
      this.dormBindVisible = true
    },
    async saveDormBind() {
      if (!this.dormBindForm.BuildingId) return this.$message.warning('请选择宿舍楼')
      if (this.dormBindForm.Direction !== 'in' && this.dormBindForm.Direction !== 'out' && this.dormBindForm.Direction !== 'auto') return this.$message.warning('请选择终端方向')
      this.dormBindLoading = true
      try {
        const res = await saveDormDeviceBinding(this.dormBindForm)
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '保存成功')
          this.dormBindVisible = false
          await this.loadDormBindSummary()
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败')
        }
      } finally {
        this.dormBindLoading = false
      }
    },
    async disableDormBind() {
      if (!this.dormBindForm.Id) return
      await this.$confirm('确认停用该绑定？', '提示', { type: 'warning' })
      const res = await disableDormDeviceBinding({ id: this.dormBindForm.Id })
      if (res.data && res.data.success) {
        this.$message.success('已停用')
        this.dormBindVisible = false
        await this.loadDormBindSummary()
      } else {
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    },

    formatTouchTypeDirection: function (row, column) {

      if (row.TouchTypeDirection == "inout") {
        return "出入";
      } else if (row.TouchTypeDirection == "in") {
        return "进入";
      } else if (row.TouchTypeDirection == "out") {
        return "离开";
      } else {
        return "";
      }
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      const id = treeNodeDeptId(data)
      if (!id) return
      this.DepartmentId = id
      this.handleQuery();
      this.loadCameraList(id);
    },

    /**
     * 拉取本校「仅联动录像」摄像头。最后更新：2026-11-01
     */
    loadCameraList(schoolId) {
      if (!schoolId) {
        this.cameraList = [];
        return;
      }
      axios.get(`${BaseApiUrl}/api/KqtCameraDevice/GetListBySchool`, {
        params: { schoolId, usage: "GateVideo" }
      }).then((res) => {
        this.cameraList = (res.data && res.data.success) ? (res.data.response || []) : [];
      }).catch(() => {
        this.cameraList = [];
      });
    },

    /** 联动录像下拉展示名 */
    formatGateVideoCameraLabel(item) {
      if (!item) return "";
      return `${item.DeviceName} (${item.DeviceId})`;
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      const para = {
        page: this.page,
        intPageSize: 10,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "2"
      }
      this.listLoading = true;

      testapi();
      // dormBound 由接口按 DormDeviceBinding 过滤分页。最后更新：2026-10-26
      getKqtDeviceTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        this.loadDormBindSummary();
      }).catch(() => {
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.loadCameraList(row.DepartmentId || this.DepartmentId);
      this.editFormVisible = true;
      this.editForm = Object.assign({ InstallPosition: "" }, row);
    },
    //显示新增界面
    handleAdd() {
      if (!toDeptId(this.DepartmentId)) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.loadCameraList(this.DepartmentId);
      this.addFormVisible = true;
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        DepartmentId: this.DepartmentId,
        TerminalTypeId: "2",
        IsPush: true
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 刷新设备状态
    refreshDeviceStatus() {
      if (!this.DepartmentId) {
        this.$message({
          message: "请选择要刷新状态的部门！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认刷新该部门下设备的状态吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          // 调用刷新设备状态接口，使用部门 ID
          let para = { departmentId: this.DepartmentId };
          refreshDeviceInfo(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "该部门下设备状态刷新成功",
                type: "success",
              });
              this.handleQuery(); // 刷新列表
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.bind-help {
  margin-top: 4px;
  color: #7c8aa0;
  font-size: 12px;
  line-height: 1.45;
}

.terminal-content-panel {
  padding: 12px 14px;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
